import React, { useState, useEffect } from 'react';
// import dayjs from 'dayjs';
import _find from 'lodash/find';
import styles from './tms.module.scss';
import {
  KoLoader, KoDP, KoText, KoRow, KoCol, KoFlex, KoCard, KoTag, KoDateFormatter, KoEmpty, KoModal, KoButton,
  KoTitle
} from 'packages';
import { InboxAPI } from '../inbox.service';
import SheetDetails from './sheetDetails';
import SheetDashboard from './sheetDashboard';
import { getDateRange } from 'shared/utils';
export default function TimeSheetApproval() {
  const [isLoading, setLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState();
  const [requesters, setApprovelRequesters] = useState();
  const [userTotalHours, setUserTotalHours] = useState([]);
  const [isOpenWorkspace, setOpenWorkspaceModal] = useState(false);
  const [selectedWorkspace, setSelectedWorkspace] = useState();
  const [weeklyTotalHours ] = useState();
  const [workspaceInfo, setWorkspaceInfo] = useState([]);
  const [selectedWorkspaceUser ] = useState();
  const [filterBy ] = useState(`This Year`);

  useEffect(() => {
    fetchUserTotalHours(getDateRange('currentYear'));
    getUsersList(getDateRange('currentYear'));
  }, []);

  const getUserRelatedData = (userId, q=filterBy, isLoadUser) => {
    const qu= _find(FILTER, (item) => item.label === q);
    getWorkspaceData(userId, getDateRange(qu?.key));
  };

  const getUserWorkspaceData = (userId) => {
    const qu= _find(FILTER, (item) => item.label === filterBy);
    setLoading(true);
    setWorkspaceInfo([]);
    InboxAPI.getUsersbyTimeSheetId(getDateRange(qu?.key)).then(
      (data) => {
        setLoading(false);
        setApprovelRequesters(data['users']);
        let cuser = data?.users?.find((item) => item.userId === userId);
        setSelectedUser(cuser || []);
        getUserRelatedData(userId, filterBy);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const getWorkspaceData = (userId, query) => {
    setLoading(true);
    if (!userId) {
      setLoading(false);
      return;
    }
    InboxAPI.getAllWorkspace(userId, query).then(
      (data) => {
        setWorkspaceInfo(data?.workspace || []);
        setLoading(false);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const getUsersList = (q, filter) => {
    setLoading(true);
    setWorkspaceInfo([]);
    InboxAPI.getUsersbyTimeSheetId(q).then(
      (data) => {
        setLoading(false);
        setApprovelRequesters(data['users']);
        setSelectedUser(data?.users?.length > 0 ? data?.users[0] : [  ]);
        getUserRelatedData(data?.users?.length > 0 ? data?.users[0]?.userId : null, filter || filterBy);
      },
      (err) => {
        setLoading(false);
      }
    );
  };

  const fetchUserTotalHours = (q) => {
    setLoading(true);
    InboxAPI.getUserTotalHours(q).then(
      (data) => {
        setUserTotalHours(data?.worklogs || []);
        setLoading(false);
      },
      (err) => {
        setLoading(false);
      }
    );
  };
  const convertMinutesToHHMM = (minutes) => {
    let hours = Math.floor(minutes / 60);
    let remainingMinutes = minutes % 60;
    return `${hours}.${remainingMinutes < 10 ? '0' : ''}${remainingMinutes}`;
  };


  const monthlyBillableMinutes = [];
  const monthlyNonBillableMinutes = [];
  const monthlyGetLabel = [];
  const monthlyTotalHours = [];

  if (userTotalHours && userTotalHours.length > 0) {
    userTotalHours.forEach(entry => {
      // billableMinutes.push(entry.billableMinutes);
      // nonBillableMinutes.push(entry.nonBillableMinutes);
      monthlyBillableMinutes.push(convertMinutesToHHMM(entry.totalBillableMinutes));
      monthlyNonBillableMinutes.push(convertMinutesToHHMM(entry.totalNonBillableMinutes));
      monthlyGetLabel.push(entry.profile.firstName);
      monthlyTotalHours.push(convertMinutesToHHMM(entry.totalMinutes));
    });
  }


  // const monthChange=(date,dateString)=>{
  //   setMonthVal(date);
  // };

  const onChangeWorkspace = (value, status) => {
    value['status'] = status;
    setSelectedWorkspace(value);
    setOpenWorkspaceModal(true);
  };

  const FILTER = [
    {
      key:'alltime',
      label: "All Time"
    },
    {
      key: "lastWeek",
      label: "Last Week"
    },
    {
      key: "currentWeek",
      label: "This Week"
    },
    {
      key: "lastMonth",
      label: "Last Month"
    },
    {
      key: "currentMonth",
      label: "This Month"
    },
    {
      key: "last3Months",
      label: "Last 3 Months"
    },
    {
      key: "last6Months",
      label: "Last 6 Months"
    },
    {
      key: "currentYear",
      label: "This Year"
    },
    {
      key: "lastYear",
      label: "Last Year"
    }
  ];
  




  const dateRange= () => {
    let item = FILTER.find((item) => item.label === filterBy);
    return getDateRange(item?.key);
  };

  return (
    <>
      {isLoading && <KoLoader />}
      <div className={`${styles.wrapper}`}>
        <div className={`${styles.secondWrapper} ${requesters?.length === 0 ? styles.activeSplit : ''}`}>
          {requesters?.length > 0 &&<div className={styles.sideNav}>
            <div className={styles.sideNavList}>
              <ul>
                {requesters?.map((data, index) => {
                  return (
                    <li className={selectedUser?.userId === data?.userId ? styles.active : ''} key={index} onClick={() => { setSelectedUser(data); getUserRelatedData(data?.userId, filterBy); }}>
                      <div className={`${styles.circle}  ${styles[data ?
                        data?.profile?.firstName?.charAt(0).toLowerCase() : 'a']}`}>
                        {data?.profile?.['logo'] ?
                          <KoDP logo={data?.profile?.['logo']} className={styles.profile} width={30} height={30} />
                          :
                          <KoText className={`${styles.letter}`} text={data?.profile?.firstName?.charAt(0)} />}
                      </div>
                      <div className={styles.sideNavContent}>
                        <div className={styles.sideNavText} onClick={() => setSelectedUser({ userId: data?.userId, ...data?.profile })}>
                          <KoText ellipsis={true} text={`${data?.profile?.firstName} `} />
                          <KoText ellipsis={true} className={styles.email} text={data?.profile?.email} />
                        </div>
                        {data?.waitingCount > 0 && <div className={styles.sideNavTextBadge}>
                          <KoText text={`${data?.waitingCount > 0 ? `${data?.waitingCount}` : ''}`} />
                        </div>}
                      </div>

                    </li>
                  );
                })}
              </ul>
            </div>
          </div>}
          <div className={styles.mainContent}>
            <div className={styles.wosList}>
              <KoRow>
                <KoCol span={24}>
                  {workspaceInfo?.length > 0 ?
                    <KoFlex wrap="wrap" gap="small" className={styles.listSection}>
                      {workspaceInfo?.map((wos, i) =>
                        <KoCard className={`${styles.woscard} ${wos?.workspace === selectedWorkspace?.workspace ? styles.activeWorkspace : ''}`}
                          key={wos?.workspace}
                          hoverable={true}>
                          <div className={styles.aLink}>
                            <div onClick={() => { }} className={styles.panelHeader}>
                              <div className={`${styles.titleKey} profileChar`}>
                                <div className={`${styles.squareDP} ${wos?.name?.charAt(0) ? wos?.name?.charAt(0).toLowerCase() : 'a'}`}>
                                  {wos?.['cutomerLogo'] ?
                                    <KoDP shape={'default'} logo={wos?.['cutomerLogo']} width={25} height={'auto'} />
                                    :
                                    <KoText className={`${styles.letter}`} text={wos?.customer?.charAt(0)} />
                                  }
                                </div>
                                <div className={styles.titleValue}>
                                  <div className={styles.verified}>
                                    <KoText className={styles.panelHeaderTitle} ellipsis={true} text={wos?.name} />
                                  </div>
                                  <KoTitle className={styles.title} ellipsis={true} text={wos?.customer} level={4} />
                                </div>
                              </div>
                              <div className={styles.descriptionDate}>
                                <div className={styles.description} >
                                  <div className={styles.panelHeaderTextWrapper}>
                                    <KoText text={`Billable: `} className={styles.panelHeaderText} />
                                    <KoText text={`${wos?.totalBillableWorkHours ?? 0} `} className={styles.panelHeaderTextBold} />
                                  </div>
                                  <div className={styles.panelHeaderTextWrapper}>
                                    <KoText text={`Non-Billable: `} className={styles.panelHeaderText} />
                                    <KoText text={`${wos?.totalNonBillableWorkHours ?? 0} `} className={styles.panelHeaderTextBold} />
                                  </div>
                                </div>
                                <div className={`${styles.statusOnWorkspaceDate}`}>
                                  <div className={styles.link}>
                                    <div className={styles.row}>
                                      <KoText className={styles.date} text='Onboarded on: ' />
                                      <KoDateFormatter format='DD-MMM-YYYY' data={wos?.onBoarding || wos.createdAt} className={styles.date} />
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className={`${styles.statusOnWorkspace} customTagLink`}>
                                {wos?.rejectCount > 0 &&
                                    <KoTag color='rejected' radius={true} custom={true} iscount={false}  onClick={() => onChangeWorkspace(wos, 3)} value={`Rejected - ${wos?.rejectCount ?? 0}`} bordered={false} />
                                }
                                {wos?.waitingCount > 0 &&
                                    <KoTag color='pending' radius={true} custom={true} iscount={false} onClick={() => onChangeWorkspace(wos, 1)} value={`Waiting - ${wos?.waitingCount ?? 0}`} bordered={false} />
                                }
                                {wos?.approvedCount > 0 &&
                                    <KoTag color='approved' radius={true} custom={true} iscount={false}  onClick={() => onChangeWorkspace(wos, 2)} value={`Approved - ${wos?.approvedCount ?? 0}`} bordered={false} />
                                }
                              </div>
                            </div>
                          </div>
                        </KoCard>
                      )}
                    </KoFlex>
                    :
                    <KoFlex wrap="wrap" gap="small" className={styles.emptySection}>
                      <KoEmpty subText="" icon={'EmptyTwoTone'} title="You have no assigned Timesheet" />
                    </KoFlex>
                  }
                </KoCol>
              </KoRow>
            </div>
          </div>
        </div>

        <KoModal
          title={selectedWorkspace?.status === 0 ?
            <div className={`${styles.modalHeader}`}>
              <div className={`${styles.circle}  ${styles[selectedWorkspaceUser ?
                selectedWorkspaceUser?.profile?.firstName?.charAt(0).toLowerCase() : 'a']}`}>
                {selectedWorkspaceUser?.profile?.['logo'] ?
                  <KoDP logo={selectedWorkspaceUser?.profile?.['logo']} className={styles.profile} width={30} height={30} />
                  :
                  <KoText className={`${styles.letter}`} text={selectedWorkspaceUser?.profile?.firstName?.charAt(0)} />}
              </div>
              <div className={styles.sideNavContent}>
                <div className={styles.sideNavText}>
                  <KoText ellipsis={true} text={selectedWorkspaceUser?.profile?.firstName} />
                  <KoText ellipsis={true} className={styles.email} text={selectedWorkspaceUser?.profile?.email} />
                </div>
              </div>
            </div>
            :
            <div className={styles.modalHeader}>
              <KoDP shape={'default'} logo={selectedWorkspace?.['cutomerLogo']} width={25} height={'auto'} />
              <KoTitle level={5} text={selectedWorkspace?.['name']} />
            </div>
          }
          centered
          open={isOpenWorkspace}
          handleOk={() => { setOpenWorkspaceModal(false); }}
          onClose={() => { setOpenWorkspaceModal(false); }}
          width={'98vw'}
          footer={[
            <KoButton key='cancel' label='Close' onClick={() => setOpenWorkspaceModal(false)} />
          ]}
        >
          {/* {isLoading && <KoLoader />} */}
          {selectedWorkspace?.status === 0 ?
            <SheetDashboard weeklyTotalHours={weeklyTotalHours} selectedWorkspaceUser={selectedWorkspaceUser} />
            : <SheetDetails dateRange={dateRange} getUsersList={getUsersList} setOpenWorkspaceModal={() => setOpenWorkspaceModal(false)} userId={selectedUser?.userId}
              getWorkspaces={getUserWorkspaceData} project={selectedWorkspace} />
          }
        </KoModal>
      </div>
    </>
  );
}
